import { UseFlowRunsLogsAdapterReturn } from './hooks/useAdapter';
import { UseFlowRunsLogsFilterResponse } from './hooks/useFilter';
import { UseRepositoryResponseType } from './hooks/useRepository';
import { FlattenedLogItem } from 'js/components/data_flows/cards/FlowRunLogs/hooks/useFlattenedLogs';

type Severity = 'INFO' | 'WARNING' | 'ERROR';
type LogType = 'EVENT' | 'LOG';
type ResourceType = 'SOURCE' | 'SINK' | 'TRANSFORMER';

export enum SeverityEnum {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export type Log = {
  log: string;
  log_id?: string;
  log_type: LogType;
  severity: Severity;
  resource_id?: number;
  resource_type?: ResourceType;
  timestamp?: number;
  run_id: number;
};

export type PaginatedLog = Log & {
  _pageNumber?: number;
  _indexInPage?: number;
};

export type FlowRunLogsData = {
  originNodeId: string;
  flowNodeId: number;
  connectorType: string;
};

export type DateRange = {
  from: number;
  to: number;
};

export type UseFlowRunsLogsResponseType = {
  hasError: boolean;
  isFetchingLogs: boolean;
  isPageSetupCompleted: boolean;
  showInitialLoader: boolean;
  actions: {
    onRefresh: () => void;
    loadMoreLogs?: () => Promise<void>;
    clearLogs: UseFlowRunsLogsAdapterReturn['clearLogs'];
  };
  paging: {
    isFirstPageRendered: boolean;
    hasMore: boolean;
  };
  runs: {
    data: Record<string, { data_sinks: any[]; data_sources: any[]; data_sets: any[] }> | null;
  };
  logs: {
    data: any;
    meta: any;
  };
  date: {
    startDate: number; // Kept for backward compatibility
    dateRange: DateRange;
    onDateChange: (value: number) => void;
    onStartDateChanged: (value: number | DateRange, newRunId?: string) => void;
  };
  filter: UseFlowRunsLogsFilterResponse;
  repository: UseRepositoryResponseType;
};
